var map = {
	"./company/5698532.jpg": 7363,
	"./company/bodsjpg.jpg": 9011,
	"./company/tnlogo.png": 7816,
	"./company/universiti-malaysia-pahang-logo.png": 8956,
	"./json.jpg": 4674,
	"./projects/default-project.jpg": 8239,
	"./tech/icons8-.net-framework-144.png": 5743,
	"./tech/icons8-.net-framework-48.png": 1896,
	"./tech/icons8-.net-framework-96.png": 9881,
	"./tech/icons8-android-studio-144.png": 1607,
	"./tech/icons8-android-studio-96.png": 7697,
	"./tech/icons8-angular-144.png": 477,
	"./tech/icons8-angularjs-96.png": 296,
	"./tech/icons8-api-96.png": 4125,
	"./tech/icons8-app-store-144.png": 3242,
	"./tech/icons8-app-store-96.png": 3518,
	"./tech/icons8-c-sharp-logo-96.png": 1617,
	"./tech/icons8-cloud-firestore-96.png": 1812,
	"./tech/icons8-dart-144.png": 5844,
	"./tech/icons8-dart-96.png": 4464,
	"./tech/icons8-external-link-144.png": 3513,
	"./tech/icons8-firebase-96.png": 1324,
	"./tech/icons8-flutter-144.png": 9857,
	"./tech/icons8-flutter-96.png": 6971,
	"./tech/icons8-google-firebase-console-144.png": 1089,
	"./tech/icons8-google-play-96.png": 6717,
	"./tech/icons8-html-144.png": 7500,
	"./tech/icons8-html-5-96.png": 1802,
	"./tech/icons8-java-144.png": 5191,
	"./tech/icons8-java-96.png": 1678,
	"./tech/icons8-javascript-96.png": 9170,
	"./tech/icons8-microsoft-sql-server-144.png": 6934,
	"./tech/icons8-microsoft-sql-server-96.png": 122,
	"./tech/icons8-mysql-144.png": 8173,
	"./tech/icons8-mysql-logo-96.png": 5919,
	"./tech/icons8-play-store-144.png": 6201,
	"./tech/icons8-spring-boot-144.png": 9863,
	"./tech/icons8-spring-boot-96.png": 8033,
	"./tech/icons8-typescript-144.png": 8534,
	"./tech/icons8-typescript-96.png": 586,
	"./tech/icons8-visual-basic-96.png": 1650,
	"./tech/icons8-visual-studio-144.png": 6724,
	"./tech/icons8-visual-studio-96.png": 5520,
	"./tech/icons8-visual-studio-code-2019-144.png": 2731,
	"./tech/icons8-visual-studio-code-2019-48.png": 4484,
	"./tech/icons8-visual-studio-code-2019-96.png": 1589,
	"./tech/icons8-vue-js-96.png": 5585,
	"./tech/icons8-xamarin-144.png": 9621,
	"./tech/icons8-xamarin-96.png": 2639,
	"./tech/icons8-xaml-96.png": 6147,
	"./wj/devimg.png": 6167
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;